<template>
  <div v-if="hasEvent">
    <base-time-key-rp
      :event-identifier="eventIdentifier"
      :hash="hash"
      :new-hash-interval="newHashInterval"
      :logo="logo"
      :has-buttons="hasButtons"
      :auto-refresh="autoRefresh"
      :current-time="currentTime"
      :countdown="countDown"
    />
  </div>
  <div
    v-else
    class="no_lesson"
  >
    <img
      class="logo"
      :src="'/' + logo"
      alt="Academy Attendance"
    >
    <div class="text">
      <h2>{{ trans('pptQR.no_class_found') }}</h2>
    </div>
  </div>
</template>

<script>
import BaseTimeKeyRp from '@/employees/DynamicKey/BaseTimeKeyRp'

export default {
  name: 'ClassroomTimeKeyRp',

  components: {
    BaseTimeKeyRp,
  },

  props: {
    backToLessonUrl: {
      required: true,
      type: String,
    },
    eventIdentifier: {
      required: true,
      type: String,
    },
    eventId: {
      required: false,
      type: Number,
      default: 0,
    },
    nrRegisteredStudents: {
      require: false,
      type: Number,
      default: 0,
    },
    hash: {
      required: true,
      type: String,
    },
    newHashInterval: {
      required: true,
      type: Number,
    },
    logo: {
      type: String,
      default: 'img/aatt.png',
      required: false,
    },
    hasButtons: {
      type: Boolean,
      default: true,
    },
    autoRefresh: {
      type: Boolean,
      default: false,
    },
    hasEvent: {
      type: Boolean,
      required: true,
    },
    currentTime: {
      type: Number,
      required: true,
    },
    countDown: {
      type: Number,
      required: false,
      default: 30,
    },
  },
}
</script>

<style scoped>
    .no_lesson {
      text-align: center;
      background: white;
      padding-bottom: 50px;
    }

    .logo {
      max-height: 100px;
      margin-top: 30px;
    }

</style>
